import {beginAjaxCall} from "./ajaxStatusActions";
import _ApiCli from "../../helpers/ApiCli";

let Ajaxcall = new _ApiCli();

const Constants = {
  "locationFilter": {"test": "test"},
  "locations": ["test"],
  "verticalFilter": {"test": "test"},
  "verticals": ["test"],
  "payrollFilter": {"test": "test"},
  "payrolls": ["test"],
  "officeLocationFilter": {"test": "test"},
  "officeLocations": ["test"]
};

export function storeConstants(constants) {
  return { type: 'GET_CONSTANT_SUCCESS', constants}
}

export function store() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call = Ajaxcall.asyncAction("/constant/getAllConstants", "get", null, null, dispatch);
    call.then((response) => {
      for (let data of response.data['data']) {
        let result = {};
        for (let val of data['values']) {
          result[val] = val;
        }
        Constants[data.type + "Filter"] = result;
        Constants[data.type + "s"] = data['values'];
      }
      dispatch(storeConstants(Constants));
    }).catch((error) => {
      console.log(error);
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/constantActions.js
 **/